import { TypePolicies } from '@apollo/client';

export const typePolicies: TypePolicies = {
  Topic: {
    fields: {
      files: {
        // Preserve files field if not queried
        merge(existing, incoming) {
          return incoming ?? existing;
        },
      },
      tags: {
        // Preserve tags field if not queried
        merge(existing, incoming) {
          return incoming ?? existing;
        },
      },
    },
  },
  Application: {
    fields: {
      tags: {
        // Preserve tags field if not queried
        merge(existing, incoming) {
          return incoming ?? existing;
        },
      },
    },
  },
  Question: {
    fields: {
      options: {
        merge: false,
      },
    },
  },
  Section: {
    fields: {
      questions: {
        merge: false,
      },
    },
  },
  LocalQuestionnaire: {
    merge: true,
    fields: {
      documentConfirmations: {
        merge(existing, incoming) {
          return incoming ?? existing;
        },
      },
    },
  },
  CompanyChat: {
    fields: {
      messages: {
        merge: false, // Don't try to merge messages array, just replace it
      },
    },
  },
};
